/** Reads SSE data frames across arbitrary UTF-8/network chunk boundaries. */
export async function readSseStream(
  stream: ReadableStream<Uint8Array>,
  onData: (data: string) => void,
): Promise<void> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let data: string[] = [];
  const consumeLine = (line: string) => {
    if (!line) {
      if (data.length) onData(data.join('\n'));
      data = [];
    } else if (line === 'data' || line.startsWith('data:')) {
      data.push(line.slice(5).replace(/^ /, ''));
    }
  };
  try {
    while (true) {
      const { done, value } = await reader.read();
      buffer += decoder.decode(value, { stream: !done });
      let match: RegExpExecArray | null;
      while ((match = /\r\n|\r|\n/.exec(buffer))) {
        // A CR at the end may be half of CRLF in the next chunk.
        if (!done && match[0] === '\r' && match.index === buffer.length - 1) break;
        consumeLine(buffer.slice(0, match.index));
        buffer = buffer.slice(match.index + match[0].length);
      }
      if (buffer.length + data.reduce((size, line) => size + line.length, 0) > 1024 * 1024) {
        throw new Error('SSE frame exceeds maximum size');
      }
      if (done) break;
    }
  } finally {
    await reader.cancel().catch(() => undefined);
    reader.releaseLock();
  }
}
